import { useQuery } from "@tanstack/react-query";
import type { Company } from "@resume-cloudflare/shared";
import { api } from "./api";

export function useCompanies() {
  return useQuery({
    queryKey: ["companies"],
    queryFn: () => api<Company[]>("/api/companies"),
    staleTime: 60_000,
  });
}
